import * as Factory from 'factory.ts'
import faker from 'faker'

import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import {
  type QuickBooksLogRecordConstructor,
  QuickBooksLogRecord,
} from './QuickBooksLogRecord'

export const QuickBooksLogRecordConstructorFactory =
  Factory.Sync.makeFactory<QuickBooksLogRecordConstructor>({
    id: Factory.each(() => faker.random.number()),
    description: Factory.each(() => faker.lorem.sentence()),
    timestamp: Factory.each(() => faker.date.past()),
    modelType: 'itemreceipt',
  })

export const QuickBooksLogRecordFactory = EntityFactory(
  QuickBooksLogRecord,
  QuickBooksLogRecordConstructorFactory
)
